import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Button, alpha, useTheme } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

interface OnboardingRequiredAlertProps {
  type: "payment" | "payout";
}

export function OnboardingRequiredAlert({ type }: OnboardingRequiredAlertProps) {
  const theme = useTheme();
  const navigate = useNavigate();

  const content = {
    payment: {
      title: "Complete Setup to Add Payment Methods",
      description:
        "Before you can add credit cards or bank accounts, please complete your account verification. This helps us keep your payments secure.",
    },
    payout: {
      title: "Complete Setup to Add Payout Account",
      description:
        "Before you can add a payout account, please complete your account verification. This is required to receive payouts.",
    },
  };

  const { title, description } = content[type];

  return (
    <Box
      sx={{
        borderRadius: 3,
        bgcolor: alpha(theme.palette.warning.main, 0.07),
        border: "1px solid",
        borderColor: alpha(theme.palette.warning.main, 0.2),
        p: 2.5,
        display: "flex",
        gap: 2,
        alignItems: "flex-start",
      }}
    >
      <Box
        sx={{
          width: 34,
          height: 34,
          borderRadius: "50%",
          bgcolor: alpha(theme.palette.warning.main, 0.12),
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          mt: 0.25,
        }}
      >
        <WarningAmberIcon sx={{ fontSize: "1rem", color: "warning.dark" }} />
      </Box>

      <Box sx={{ flex: 1 }}>
        <Typography sx={{ fontSize: "0.88rem", fontWeight: 700, color: "text.primary", mb: 0.5 }}>
          {title}
        </Typography>
        <Typography sx={{ fontSize: "0.78rem", color: "text.secondary", mb: 2, lineHeight: 1.5 }}>
          {description}
        </Typography>
        <Button
          size="small"
          variant="contained"
          endIcon={<ArrowForwardIcon sx={{ fontSize: "0.85rem !important" }} />}
          onClick={() => navigate("/onboarding")}
          sx={{
            bgcolor: "warning.main",
            "&:hover": { bgcolor: "warning.dark" },
            fontSize: "0.78rem",
            fontWeight: 600,
            borderRadius: "8px",
            color: "#fff",
          }}
        >
          Complete Setup
        </Button>
      </Box>
    </Box>
  );
}
